import React from "react";
import $ from "jquery";
import { notify } from "react-notify-toast";
import store from "store";
import {
  AjaxSetup,
  API_REGISTER,
  API_PROGRAM,
  API_INSTITUTE,
  API_SYNC_ACCOUNT,
  QueryParam,
  BASE_URL,
} from "../Util";
import Login from "./Login";
import { Button, Modal } from "react-materialize";
import RegisterPasswordSmile from "./components/RegisterPasswordSmile";
import FormRegister from "./components/Register";
import { Link } from "react-router-dom";
import Tab from "./components/Tab";

class SyncAccount extends Login {
  constructor(props) {
    super(props);
    this.state = {
      type: "smile",
      dataRegister: {},
      params: {},
      token: null,

      has_smile: null,
      username: "",
      password: null,
      program_id: null,
      showPassword: null,

      optionPrograms: [],
      optionInstitutes: [],

      errorUsername: null,
      errorPassword: null,
      errorInstituteId: null,
      errorOtherInstitute: null,
    };

    this.clientToken = "aa6d8694eea3d1b52aa6e4169b0a822665b56fc4";
  }

  componentDidMount() {
    let urlParams = new URLSearchParams(window.location.search);
    let token = urlParams.get("token");

    console.log("sync account " + token);

    if (!token) {
      this.props.history.push("/");
    }

    this.setState({ token });

    this.getPrograms();
    this.getInstitutes();
  }

  getPrograms = () => {
    $.get(API_PROGRAM).then((data) => {
      if (data.payload) {
        let options = [...data.payload];
        options = options.filter((opt) => opt.has_url);
        options =
          options.map((obj) => ({
            label: obj.name,
            value: obj.id,
          })) || [];

        this.setState({ optionPrograms: options });
      }
    });
  };

  getInstitutes = () => {
    $.get(API_INSTITUTE).then((data) => {
      if (data.payload) {
        let options =
          data.payload.map((obj) => ({
            label: obj.name,
            value: obj.id,
          })) || [];

        this.setState({ optionInstitutes: options });
      }
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const {
      type,
      token,
      has_smile,
      username,
      password,
      program_id,
      institute_id,
      other_institute,
    } = this.state;
    let payload = {
      username,
      password,
      program_id,
      has_smile,
      institute_id,
      other_institute,
      token,
      client_token: this.clientToken,
      device_token: "",
    };

    $.post(API_SYNC_ACCOUNT, payload)
      .then((data) => {
        if (data.success) {
          notify.show("Terima kasih permintaan anda sudah terkirim", "success");
        } else {
          notify.show("Terdapat kesalahan, silakan coba lagi", "warning");
        }
      })
      .fail((XMLHttpRequest, textStatus, errorThrown) => {
        let response;

        try {
          response = JSON.parse(XMLHttpRequest.responseText);
        } catch (e) {}

        if (response && response.error) {
          notify.show(response.message, "warning");
        }
      });
  };

  render() {
    const {
      token,
      dataRegister,
      has_smile,
      username,
      institute_id,
      other_institute,
      showPassword,
      errorUsername,
      errorPassword,
      errorInstituteId,
      errorOtherInstitute,
      optionPrograms,
      optionInstitutes,
    } = this.state;

    return (
      <div className="bg-grey">
        <div className="pt-m pb-l">
          <div className="form-auth bg-white">
            <div className="px-l py-m full-width">
              <div className="center mb-s">
                <img
                  className="form-auth-header-logo"
                  src={BASE_URL + "/img/white-label/logo/SMILE_Logo_HD.png"}
                  width={222}
                />
              </div>
              <form id="form-sync" type="post" onSubmit={this.handleSubmit}>
                <div style={{ margin: "16px auto" }}>
                  <div>Apakah anda Memiliki Akun Smile</div>
                  <div
                    className="row"
                    style={{ marginTop: "4px", marginBottom: "4px" }}
                  >
                    <div className="col s3">
                      <input
                        name="has_smile"
                        type="radio"
                        id="has_smile_1"
                        value="true"
                        onChange={(e) => this.setState({ has_smile: "true" })}
                        checked={has_smile === "true"}
                      />
                      <label htmlFor="has_smile_1">Ya</label>
                    </div>

                    <div className="col s3">
                      <input
                        name="has_smile"
                        type="radio"
                        id="has_smile_2"
                        value="false"
                        onChange={(e) => this.setState({ has_smile: "false" })}
                        checked={has_smile === "false"}
                      />
                      <label htmlFor="has_smile_2">Tidak</label>
                    </div>
                  </div>
                </div>

                {has_smile != null && has_smile === "true" ? (
                  <div className="row">
                    <div className="input-field col s12">
                      <input
                        required
                        id="username"
                        type="text"
                        value={username}
                        onChange={(e) =>
                          this.setState({ username: e.target.value })
                        }
                        className="validate"
                      />
                      <label htmlFor="username">Username SMILE</label>
                      <span className="red-text text-darken-2">
                        {errorUsername}
                      </span>
                    </div>

                    <div className="input-field col s12">
                      <input
                        required
                        id="password"
                        type={!showPassword ? "password" : "text"}
                        onChange={(e) =>
                          this.setState({ password: e.target.value })
                        }
                        className="validate"
                      />
                      <i
                        className="btn-show-hide-password material-icons"
                        onClick={(e) =>
                          this.setState({ showPassword: !showPassword })
                        }
                      >
                        {showPassword ? "visibility_off" : "visibility"}
                      </i>
                      <label htmlFor="password">Password</label>
                      {errorPassword ? (
                        <span className="red-text text-darken-2">
                          {errorPassword}
                        </span>
                      ) : null}
                    </div>

                    <div className="col s12">
                      <label>Program</label>
                      <select
                        name="program_id"
                        onChange={(e) =>
                          this.setState({ program_id: e.target.value })
                        }
                        className="browser-default"
                        required
                      >
                        <option value="">Select Option</option>
                        {optionPrograms
                          ? optionPrograms.map((opt) => (
                              <option value={opt.value}>{opt.label}</option>
                            ))
                          : null}
                      </select>
                    </div>
                  </div>
                ) : null}

                {has_smile != null && has_smile === "false" ? (
                  <div>
                    <div style={{ margin: "16px auto" }}>
                      <div>
                        <select
                          name="institute_id"
                          onChange={(e) =>
                            this.setState({ institute_id: e.target.value })
                          }
                          className="browser-default"
                          required
                          placeholder="Instansi"
                          value={institute_id}
                        >
                          <option value="">Pilih Instansi</option>
                          {optionInstitutes.map((opt) => (
                            <option value={opt.value}>{opt.label}</option>
                          ))}
                        </select>
                        {errorInstituteId ? (
                          <div className="red-text text-darken-2 font-tiny">
                            {errorInstituteId}
                          </div>
                        ) : null}
                      </div>

                      {institute_id == "other" ? (
                        <div className="input-field row">
                          <input
                            name="other_institute"
                            type="text"
                            placeholder="Instansi Lain"
                            className="col s12"
                            required
                            onChange={(e) =>
                              this.setState({ other_institute: e.target.value })
                            }
                            value={other_institute}
                          />
                          {errorOtherInstitute ? (
                            <div className="red-text text-darken-2 font-tiny">
                              {errorOtherInstitute}
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                    </div>
                  </div>
                ) : null}

                {has_smile != null ? (
                  <div className="form-auth__button-group mt-s">
                    <button type="submit" className="btn full mb-s">
                      Simpan
                    </button>
                  </div>
                ) : null}
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SyncAccount;



// WEBPACK FOOTER //
// ./src/components/Auth/SyncAccount.js